import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ShieldCheck, Globe } from "lucide-react";

// Fix J: indica si el objetivo tiene reglas de cumplimiento propias o hereda las globales.
export function ClientRulesBadge({ clientId }) {
  const [rules, setRules] = useState(null);

  useEffect(() => {
    api.get("/schedule/rules", { params: { client_id: clientId } })
      .then(({ data }) => setRules(data)).catch(() => setRules(null));
  }, [clientId]);

  if (!rules) return null;
  const own = rules.scope === "client";

  return (
    <div className="card" style={{ marginTop: 14, padding: 16, background: "var(--invict-bone-2)" }} data-testid="client-rules-badge">
      <h3 style={{ margin: "0 0 4px", fontSize: 13, fontWeight: 800, color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "0.05em" }}>Reglas de cumplimiento</h3>
      <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 6 }}>
        {own ? <ShieldCheck size={15} style={{ color: "#0f7a3d" }} /> : <Globe size={15} style={{ color: "var(--invict-text-muted)" }} />}
        <b style={{ fontSize: 13, color: own ? "#0f7a3d" : "#0A0A0A" }} data-testid="client-rules-scope">
          {own ? "Este objetivo tiene reglas propias" : "Este objetivo usa las reglas globales"}
        </b>
      </div>
      <p style={{ fontSize: 12, color: "var(--invict-text-muted)", margin: "0 0 8px" }}>
        Descanso mínimo {rules.min_rest_hours} h · Máx. corridas {rules.max_continuous_hours} h · Máx. días sin franco {rules.max_consecutive_days} · Máx. semanales {rules.max_weekly_hours} h{rules.max_monthly_hours > 0 ? ` · Máx. mensuales ${rules.max_monthly_hours} h` : ""}
      </p>
      <Link to="/admin/cronograma" style={{ fontSize: 12, fontWeight: 700, color: "#BF3437" }} data-testid="client-rules-link">
        Configurar desde el Cronograma (filtrá por este objetivo) →
      </Link>
    </div>
  );
}
